import { Cruelty, European, Gluten, Lactose, NoAdditives, Vegan, AthletesDopping } from '../Data/Images/Home';

export const INGREDIENTS_MARGIN_FACTOR = [
  { id: 1, name: 'Ashwagandha', margin_factor: 3.7 },
  { id: 25, name: 'Vitamin B7 (Biotin)', margin_factor: 4 },
  { id: 4, name: 'Calcium', margin_factor: 3 },
  { id: 5, name: 'Chromium', margin_factor: 4 },
  { id: 6, name: 'Coenzyme Q10', margin_factor: 3 },
  { id: 7, name: 'Copper', margin_factor: 25 },
  { id: 11, name: 'Iron', margin_factor: 4 },
  { id: 12, name: 'Magnesium', margin_factor: 3 },
  { id: 13, name: 'Manganese', margin_factor: 4 },
  { id: 14, name: 'MSM (Methylsulfonylmethane)', margin_factor: 2.8 },
  { id: 15, name: 'Omega-3', margin_factor: 2.25 },
  { id: 17, name: 'Selenium', margin_factor: 4 },
  { id: 18, name: 'Vitamin A', margin_factor: 4 },
  { id: 20, name: 'Vitamin B12', margin_factor: 2 },
  { id: 21, name: 'Vitamin B2', margin_factor: 4 },
  { id: 24, name: 'Vitamin B6', margin_factor: 4 },
  { id: 26, name: 'Vitamin B9 (Folat)', margin_factor: 4 },
  { id: 27, name: 'Vitamin C', margin_factor: 4 },
  { id: 28, name: 'Vitamin D3', margin_factor: 5 },
  { id: 29, name: 'Vitamin E', margin_factor: 4 },
  { id: 30, name: 'Vitamin K', margin_factor: 4 },
  { id: 19, name: 'Vitamin B1', margin_factor: 4 },
  { id: 22, name: 'Vitamin B3 (Niacin)', margin_factor: 3.5 },
  { id: 23, name: 'Vitamin B5 (Pantothenic acid)', margin_factor: 4 },
  { id: 16, name: 'Potassium', margin_factor: 3.5 },
  { id: 8, name: 'Curcuma', margin_factor: 3.5 },
  { id: 31, name: 'Zinc', margin_factor: 4 },
  { id: 33, name: 'Vitamin B9 (L-5-MTHF)', margin_factor: 4 },
  { id: 34, name: 'Vitamin B12 (Methylcobalamin)', margin_factor: 4 },
  { id: 35, name: 'Bacillus coagulans Unique IS-2® (15 billion CFU)', margin_factor: 2.67 },
  { id: 36, name: 'Lutein', margin_factor: 4 },
  { id: 37, name: 'Iodine', margin_factor: 1.5 },
];

const PRICE_PER_MG_ACTIVE = [
  {
    id: 1,
    name: 'Ashwagandha',
    pricePerMgActive: 0.022, // old price: 0.027997
  },
  {
    id: 25,
    name: 'Vitamin B7 (Biotin)',
    pricePerMgActive: 8.11512,
  },
  {
    id: 4,
    name: 'Calcium',
    pricePerMgActive: 0.01917,
  },
  {
    id: 5,
    name: 'Chromium',
    pricePerMgActive: 69.13318684,
  },
  {
    id: 6,
    name: 'Coenzyme Q10',
    pricePerMgActive: 0.054, // old price: 0.1215
  },
  {
    id: 7,
    name: 'Copper',
    pricePerMgActive: 6.267857143,
  },
  {
    id: 11,
    name: 'Iron',
    pricePerMgActive: 0.07626887403,
  },
  {
    id: 12,
    name: 'Magnesium',
    pricePerMgActive: 0.03, // old price: 0.04729411765
  },
  {
    id: 13,
    name: 'Manganese',
    pricePerMgActive: 2.678787879,
  },
  {
    id: 14,
    name: 'MSM (Methylsulfonylmethane)',
    pricePerMgActive: 0.007, // old price: 0.01182857143
  },
  {
    id: 15,
    name: 'Omega-3',
    pricePerMgActive: 0.01944,
  },
  {
    id: 17,
    name: 'Selenium',
    pricePerMgActive: 28.6416,
  },
  {
    id: 18,
    name: 'Vitamin A',
    pricePerMgActive: 4.05756,
  },
  {
    id: 20,
    name: 'Vitamin B12',
    pricePerMgActive: 8.11512,
  },
  {
    id: 21,
    name: 'Vitamin B2',
    pricePerMgActive: 0.202878,
  },
  {
    id: 24,
    name: 'Vitamin B6',
    pricePerMgActive: 0.202878,
  },
  {
    id: 26,
    name: 'Vitamin B9 (Folat)',
    pricePerMgActive: 0.86904,
  },
  {
    id: 27,
    name: 'Vitamin C',
    pricePerMgActive: 0.011, // old price: 0.01908
  },
  {
    id: 28,
    name: 'Vitamin D3',
    pricePerMgActive: 33.813, // old price: 50.72
  },
  {
    id: 29,
    name: 'Vitamin E',
    pricePerMgActive: 0.052,
  },
  {
    id: 30,
    name: 'Vitamin K',
    pricePerMgActive: 8.11512,
  },
  {
    id: 19,
    name: 'Vitamin B1',
    pricePerMgActive: 0.144, // old price: 0.202878
  },
  {
    id: 22,
    name: 'Vitamin B3 (Niacin)',
    pricePerMgActive: 0.0473382,
  },
  {
    id: 23,
    name: 'Vitamin B5 (Pantothenic acid)',
    pricePerMgActive: 0.202878,
  },
  {
    id: 16,
    name: 'Potassium',
    pricePerMgActive: 0.013, // old price: 0.01801983079
  },
  {
    id: 8,
    name: 'Curcuma',
    pricePerMgActive: 0.022365,
  },
  {
    id: 31,
    name: 'Zinc',
    pricePerMgActive: 0.175, // old price: 0.2338246253
  },
  {
    id: 33,
    name: 'Vitamin B9 (L-5-MTHF)',
    pricePerMgActive: 0.86904,
  },
  {
    id: 34,
    name: 'Vitamin B12 (Methylcobalamin)',
    pricePerMgActive: 8.11512,
  },
  {
    id: 35,
    name: 'Bacillus coagulans Unique IS-2® (15 billion CFU)',
    pricePerMgActive: 0.01690911,
  },
  {
    id: 36,
    name: 'Lutein',
    pricePerMgActive: 0.0408,
  },
  {
    id: 37,
    name: 'Iodine',
    pricePerMgActive: 15.34090909,
  },
  {
    // SHI-632: magnesium is now bisglycinate (id 39); citrate (id 12) is
    // retired for new formulas but kept above because old quizzes may still
    // reference it. Both are priced identically — match both ids.
    id: 39,
    name: 'Magnesium (Bisglycinate)',
    pricePerMgActive: 0.03,
  },
];

export const ICONS_DATA = [Cruelty, European, Gluten, Lactose, NoAdditives, Vegan, AthletesDopping];

export const getIngredientMonthlyPrice = (ingredient, quantity) => {
  const normalizedQuantity = Number(quantity);
  if (!Number.isFinite(normalizedQuantity) || normalizedQuantity <= 0) return 0;

  const ingredientPrice = PRICE_PER_MG_ACTIVE.find(
    (item) => Number(item.id) === Number(ingredient?.ingredient_id),
  );
  if (!ingredientPrice) return 0;

  // 1.17 is commission rate, 0.5 operation rate, 1.07 is vat
  return Number(((normalizedQuantity * ingredientPrice.pricePerMgActive + 0.5) * 1.17 * 1.07).toFixed(2));
};

export const calculateIngredientPrice = (
  ingredient,
  quantity,
  setPricesData,
  setPaymentLink,
  setSubscription,
  allIngredientPrices,
  canUpdateSub = true,
) => {
  if (quantity > 0) {
    // const ingredientPriceData = allIngredientPrices?.data?.find(
    //   (item) => item?.ingredient_id === ingredient?.ingredient_id
    // );
    // console.log('quantity => ', quantity);
    // const ingredientMarginFactor = INGREDIENTS_MARGIN_FACTOR?.find(
    //   (item) => item?.id === ingredient?.ingredient_id
    // );

    // const dailyDose = quantity / parseFloat(ingredientPriceData?.active_percentage);

    // const thirtyDaysDose = parseFloat(ingredientPriceData?.quote_per_mg) * dailyDose * 30;

    // const finalPrice = (thirtyDaysDose * ingredientMarginFactor?.margin_factor + 0.5) * 1.17 * 1.07;
    const finalPriceWithNewCalculations = getIngredientMonthlyPrice(ingredient, quantity);

    // console.log(
    //   "finalPrice and finalPriceWithNewCalculations => ",
    //   ingredient?.ingredient,
    //   finalPrice.toFixed(2),
    //   finalPriceWithNewCalculations.toFixed(2),
    //   finalPrice.toFixed(2) === finalPriceWithNewCalculations.toFixed(2)
    // );
    setPricesData((prev) => ({
      ...prev,
      [ingredient?.ingredient]: finalPriceWithNewCalculations.toFixed(2),
    }));
  } else {
    setPricesData((prev) => ({ ...prev, [ingredient?.ingredient]: 0 }));
  }
  if (canUpdateSub) {
    setPaymentLink(null);
    setSubscription({
      title: '',
      duration: '',
      description: '',
      subId: 1,
      expirey: Date,
    });
  }
};

export const MICRO_INGREDIENT_IDS = [25, 18, 20, 26, 28, 30, 33, 34, 37];

// Ingredients whose "Why we added this" copy is non-personalized (no customer-data
// signal): Ashwagandha (1), Coenzyme Q10 (6), Curcuma (8). For these we display the
// static catalog description, which the backend already returns per-language as
// `static_description` (from the DB, with en fallback). Using it instead of the
// AI/cache `description` keeps the copy DB-driven (no hardcoded prompt text), fixes
// wrong-language fallbacks (e.g. French showing German), and lets the carousel
// open-rule treat them as static since `description === static_description`.
export const NON_PERSONALIZED_INGREDIENT_IDS = [1, 6, 8];

export const withStaticDescriptions = (ingredients) =>
  (ingredients || []).map((ing) =>
    NON_PERSONALIZED_INGREDIENT_IDS.includes(ing?.ingredient_id)
      ? { ...ing, description: ing?.static_description || ing?.description }
      : ing,
  );
